module.exports = __webpack_public_path__ + "img/people_twj.bb5629d1.png";